var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home",class:{ ios_header: this.$fn.cookies.getIsios() }},[_c('van-nav-bar',{attrs:{"title":"交易中心","fixed":"","placeholder":"","left-arrow":"","safe-area-inset-top":"","right-text":"切换游戏"},on:{"click-left":function($event){return _vm.onClickLeft()},"click-right":_vm.onClickRight}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }